import { AnimatePresence, Variants, motion } from "framer-motion";
import { Outlet } from "react-router-dom";

import { cn } from "@/lib/utils";
import { ThemeProvider } from "@/providers/theme-provider";
import { SidebarNav } from "@/components/sidebar-nav";

import { sidebarConfig } from "@/components/sidebar-nav/sidebar-config";
import { DashboardNavbar } from "@/components/dash-nav";
import { useSidebar } from "@/components/sidebar-nav/use-sidebar";
import { AdminSocketProvider } from "@/providers/admin-socket-provider";

export default function AdminLayout() {
  const { open } = useSidebar();

  const sidebarVariants: Variants = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
      },
    },
    exit: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };

  return (
    <>
      <ThemeProvider>
        <div className="h-full md:flex">
          <AnimatePresence mode="popLayout">
            {open && (
              <motion.aside
                variants={sidebarVariants}
                layout
                initial="hidden"
                animate="show"
                exit="exit"
                className="fixed top-0 z-30 hidden h-full md:w-[220px] lg:w-[240px] shrink-0 md:block bg-muted border-r border-r-primary/20"
              >
                <div className="overflow-y-auto h-full py-6 pr-6 lg:py-8">
                  <SidebarNav items={sidebarConfig.adminSidebar} />
                </div>
              </motion.aside>
            )}
          </AnimatePresence>
          <div
            className={cn(
              "flex-1 w-full relative",
              open && "md:ml-[220px] lg:ml-[240px]"
            )}
          >
            <DashboardNavbar />
            <div className="h-14" />
            <Outlet />
          </div>
        </div>
      </ThemeProvider>

      <AdminSocketProvider />
    </>
  );
}
